export default "__VITE_ASSET__DUOqwlSy__"